import { ApiBase, HttpMethod } from "../../core/api-base";

export type BoardConfigUpdateResponse = {
    success?: number;
    message?: string;
    item?: {
        modal_usage?: string;
        list_style?: string;
        title_enabled?: number;
        product_linker_show?: string;
        target_product_show?: string;
        ogp_preview_show?: string;
        user_info_show?: string;
        show_content?: string;
        rating_overlay_show?: string;
        date_show?: string;
        updated_at?: string | null;
    };
    errors?: Record<string, string[]>;
};

export class BoardConfigAdminApi extends ApiBase {
    public static update(form: HTMLFormElement, formData: FormData): Promise<Response> {
        return this.apiRequestWithErrorHandling(form.action, HttpMethod.Put, formData, {
            showErrors: false,
            fallbackMessage: "Board config update failed.",
        });
    }
}
